import { Box, Skeleton as MuiSkeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

function PostFormSkeleton() {
  return (
    <>
      <Skeleton animation="wave" variant="rounded" width="100%" height={40} />
      <Skeleton animation="wave" variant="rounded" width="100%" height={250} sx={{ mt: 1.5 }} />
      <Box width="60%">
        <Skeleton animation="wave" variant="rounded" width="100%" height={45} sx={{ mt: 3 }} />
        <Skeleton animation="wave" variant="rounded" width="100%" height={45} sx={{ mt: 1.5 }} />
        <Skeleton animation="wave" variant="rounded" width="100%" height={45} sx={{ mt: 1.5 }} />
        <Skeleton animation="wave" variant="rounded" width="100%" height={45} sx={{ mt: 1.5 }} />
      </Box>
    </>
  );
}

const Skeleton = styled(MuiSkeleton, { label: 'Skeleton' })(({ theme }) => ({
  '&::after': {
    background: `linear-gradient(
      90deg,
      transparent,
      ${theme.palette.custom.inputHoverBackground},
      transparent
    )`,
  },
}));

export default PostFormSkeleton;
